import * as types from '../constants/ActionTypes';

const initialState = {
  isMobile: false,
  height: null,
  width: null,
  popUp: undefined,
  popUpProps: undefined,
};

export default function environment(state = initialState, action) {
  switch (action.type) {
    case types.CHANGE_IS_MOBILE:
      return Object.assign({}, state, {
        isMobile: action.isMobile,
      });

    case types.CHANGE_WIDTH_AND_HEIGHT:
      return Object.assign({}, state, {
        height: action.height,
        width: action.width,
      });

    case types.SET_POPUP:
      return Object.assign({}, state, {
        popUp: action.popUp,
        popUpProps: action.popUpProps
      });

    case types.USER_LOGOUT_START:
      return Object.assign({}, state, {
        popUp: null,
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/environment.js